export const buildFullName = (user: any) => {
  return user ? [user.firstName, user.lastName].join(' ').trim() : 'N/A';
};
